import script from "./NavMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavMenu.vue?vue&type=script&lang=ts&setup=true"

import "./NavMenu.vue?vue&type=style&index=0&id=64a03750&scoped=true&lang=scss"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a03750"]])

export default __exports__